import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Async } from '@/shared/ui/Async';
import { Button } from '@/shared/ui/Button';
import { useSessionStore } from '@/stores/session.store';

import { CreateMasjidForm } from '../components/CreateMasjidForm';
import { useMyMasjids } from '../hooks/use-masjids';

/** The user's owned + co-managed masjids, with an inline create form. */
export function MasjidsRoute(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userId = useSessionStore((s) => s.userId);
  const query = useMyMasjids();
  const [creating, setCreating] = useState(false);

  return (
    <main className="page stack">
      <div className="row row--between">
        <h1>{t('nav.masjids')}</h1>
        {!creating ? <Button onClick={() => setCreating(true)}>{t('masjid.add')}</Button> : null}
      </div>

      {creating ? <CreateMasjidForm onCreated={() => setCreating(false)} /> : null}

      <Async query={query} isEmpty={(list) => list.length === 0} emptyMessage={t('masjid.empty')}>
        {(masjids) => (
          <ul className="stack" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {masjids.map((masjid) => (
              <li key={masjid.id} className="card stack">
                <div className="row row--between">
                  <strong>{masjid.name}</strong>
                  {masjid.adminId === userId ? (
                    <Button
                      variant="text"
                      onClick={() => navigate(`/masjids/${masjid.id}/members`)}
                    >
                      {t('members.manage')}
                    </Button>
                  ) : (
                    <span className="muted">{t('members.coManaged')}</span>
                  )}
                </div>
                {masjid.city || masjid.address ? (
                  <p className="muted">
                    {[masjid.city, masjid.address].filter(Boolean).join(' · ')}
                  </p>
                ) : null}
              </li>
            ))}
          </ul>
        )}
      </Async>
    </main>
  );
}
